import PropTypes from 'prop-types';
export const DROPZONE_SIZES = {
  DEFAULT: 'default',
  SMALL: 'small'
};
export const sizePropType = PropTypes.oneOf(Object.values(DROPZONE_SIZES));
//# sourceMappingURL=consts.js.map